"use strict";

var _toConsumableArray = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/toConsumableArray");

var _createClass = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("./utils");
/**
 * A `Storage` is a data structure that stores `Node` and `Edge` elements, with different speed/
 * memory characteristics and methods for lookup and iteration.
 */


var Storage = function Storage() {
  _classCallCheck(this, Storage);
};

exports.Storage = Storage;
/**
 * A `BasicStorage` utilizes a flat representation to enable Node/Edge lookup by ID in O(1)/O(1) and
 * traversal in O(n)/O(m).
 */

var BasicStorage =
/*#__PURE__*/
function (_Storage) {
  _inherits(BasicStorage, _Storage);

  function BasicStorage(nodes, edges) {
    var _this;

    _classCallCheck(this, BasicStorage);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BasicStorage).call(this));
    _this._nodes = nodes;
    _this._edges = edges;
    _this._nodeIdToIdx = new Map(nodes.map(function (_ref, idx) {
      var id = _ref.id;
      return [id, idx];
    }));
    _this._edgeIdToIdx = new Map(edges.map(function (_ref2, idx) {
      var id = _ref2.id;
      return [id, idx];
    }));
    return _this;
  }

  _createClass(BasicStorage, [{
    key: "nodes",
    value: function nodes() {
      return Array.from(this._nodes);
    }
  }, {
    key: "edges",
    value: function edges() {
      return Array.from(this._edges);
    }
  }, {
    key: "node",
    value: function node(id) {
      var idx = this._nodeIdToIdx.get(id);

      if (idx === undefined) throw Error("Could not find Node with specified NodeId: ".concat(id));
      return this._nodes[idx];
    }
  }, {
    key: "edge",
    value: function edge(id) {
      var idx = this._edgeIdToIdx.get(id);

      if (idx === undefined) throw Error("Could not find Edge with specified EdgeId: ".concat(id));
      return this._edges[idx];
    }
  }, {
    key: "bounds",
    value: function bounds() {
      if (this._nodes.length == 0) return {
        x: 0,
        y: 0,
        X: 0,
        Y: 0,
        width: 0,
        height: 0
      };
      var x = Number.POSITIVE_INFINITY,
          y = Number.POSITIVE_INFINITY,
          X = Number.NEGATIVE_INFINITY,
          Y = Number.NEGATIVE_INFINITY;

      this._nodes.forEach(function (node) {
        var bounds = node.shape.bounds();
        x = Math.min(x, bounds.x);
        y = Math.min(y, bounds.y);
        X = Math.max(X, bounds.X);
        Y = Math.max(Y, bounds.Y);
      });

      this._edges.forEach(function (edge) {
        var xs = edge.path.map(function (pt) {
          return pt.x;
        });
        var ys = edge.path.map(function (pt) {
          return pt.y;
        });
        x = Math.min.apply(Math, [x].concat(_toConsumableArray(xs)));
        y = Math.min.apply(Math, [y].concat(_toConsumableArray(ys)));
        X = Math.max.apply(Math, [X].concat(_toConsumableArray(xs)));
        Y = Math.max.apply(Math, [Y].concat(_toConsumableArray(ys)));
      });

      return {
        x: x,
        y: y,
        X: X,
        Y: Y,
        width: X - x,
        height: Y - y
      };
    }
  }]);

  return BasicStorage;
}(Storage);

exports.BasicStorage = BasicStorage;
/**
 * A `StructuredStorage` maintaing data structures to make node hierarchy and edge traversal easier.
 */

var StructuredStorage =
/*#__PURE__*/
function (_BasicStorage) {
  _inherits(StructuredStorage, _BasicStorage);

  function StructuredStorage(nodes, edges) {
    var _this2;

    _classCallCheck(this, StructuredStorage);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(StructuredStorage).call(this, nodes, edges));
    _this2._roots = new Set();
    _this2._parents = new Map();
    nodes.forEach(function (node) {
      _this2._roots.add(node);

      node.children.forEach(function (child) {
        if (_this2._parents.has(child)) throw Error("Node can only have 1 parent: child NodeId ".concat(child.id, ", parent NodeId ").concat(node.id));

        _this2._parents.set(child, node);
      });
    });
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = _this2._parents.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var child = _step.value;

        _this2._roots.delete(child);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    _this2._edgesFrom = new Map();
    _this2._edgesTo = new Map();
    edges.forEach(function (edge) {
      var edgesFromSource = _this2._edgesFrom.get(edge.source.node);

      if (edgesFromSource === undefined) {
        _this2._edgesFrom.set(edge.source.node, [edge]);
      } else {
        edgesFromSource.push(edge);
      }

      var edgesToTarget = _this2._edgesTo.get(edge.target.node);

      if (edgesToTarget === undefined) {
        _this2._edgesTo.set(edge.target.node, [edge]);
      } else {
        edgesToTarget.push(edge);
      }
    });
    return _this2;
  } // =============================================================================================
  // Traversal of compound node hierachy.


  _createClass(StructuredStorage, [{
    key: "parents",
    value: function parents(ns) {
      if (!utils_1.isIterable(ns)) ns = [ns];
      var parents = new Set();
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = ns[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var node = _step2.value;

          var parent = this._parents.get(node);

          if (parent) parents.add(parent);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return parents;
    }
  }, {
    key: "siblings",
    value: function siblings(ns) {
      if (!utils_1.isIterable(ns)) ns = [ns];
      var siblings = new Set();
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = ns[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var node = _step3.value;

          var parent = this._parents.get(node);

          if (parent) {
            // Is non-root node.
            parent.children.forEach(function (root) {
              return siblings.add(root);
            });
          } else {
            // Is root node.
            this._roots.forEach(function (root) {
              return siblings.add(root);
            });
          }

          siblings.delete(node);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return siblings;
    }
  }, {
    key: "children",
    value: function children(ns) {
      if (!utils_1.isIterable(ns)) return new Set(ns.children);
      return new Set(Array.from(ns).flatMap(function (n) {
        return n.children;
      }));
    }
  }, {
    key: "roots",
    value: function roots() {
      return this._roots;
    }
  }, {
    key: "ancestors",
    value: function ancestors(ns) {
      var _this3 = this;

      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          levels = _ref3.levels,
          until = _ref3.until;

      if (!utils_1.isIterable(ns)) ns = [ns];
      var ancestors = new Set();
      var visited = new Set();

      var traverse = function traverse(u, level) {
        if (u === undefined) return;
        if (levels !== undefined && level > levels) return;
        if (visited.has(u)) return;
        visited.add(u);
        ancestors.add(u);
        if (u === until) return;
        traverse(_this3._parents.get(u), level + 1);
      };

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = ns[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var node = _step4.value;
          traverse(this._parents.get(node), 1);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return ancestors;
    }
  }, {
    key: "descendants",
    value: function descendants(ns, levels) {
      if (!utils_1.isIterable(ns)) ns = [ns];
      var descendants = new Set();
      var visited = new Set();

      var traverse = function traverse(u, level) {
        if (levels !== undefined && level > levels) return;
        if (visited.has(u)) return;
        visited.add(u);
        descendants.add(u);
        u.children.forEach(function (child) {
          return traverse(child, level + 1);
        });
      };

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = ns[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var node = _step5.value;
          node.children.forEach(function (child) {
            return traverse(child, 1);
          });
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return descendants;
    }
  }, {
    key: "hasAncestor",
    value: function hasAncestor(n, ancestor) {
      var curr = this._parents.get(n);

      while (true) {
        if (curr === undefined) return false;
        if (curr === ancestor) return true;
        curr = this._parents.get(curr);
      }
    }
  }, {
    key: "hasDescendant",
    value: function hasDescendant(n, descendant) {
      return this.hasAncestor(descendant, n);
    }
  }, {
    key: "hasAncestorOrDescendant",
    value: function hasAncestorOrDescendant(n, other) {
      return this.hasAncestor(n, other) || this.hasAncestor(other, n);
    }
  }, {
    key: "leastCommonAncestor",
    value: function leastCommonAncestor(u, v) {
      var visited = new Set();
      var left = u;
      var right = v;

      while (left || right) {
        // Alternate between advancing left and right pointers up the ancestor tree. The first
        // node that is visited a second time is the lca.
        if (left) {
          if (visited.has(left)) return left;
          visited.add(left);
          left = this._parents.get(left);
        }

        if (right) {
          if (visited.has(right)) return right;
          visited.add(right);
          right = this._parents.get(right);
        }
      }

      return undefined;
    }
  }, {
    key: "greatestDifferentAncestor",
    value: function greatestDifferentAncestor(u, v) {
      var lca = this.leastCommonAncestor(u, v);
      if (lca === u || lca === v) return undefined; // If ancestor/descendant of each other.
      // Advance uptr/vptr until right before the lca or have reached roots.

      var uptr = u,
          vptr = v;

      while (true) {
        var uparent = this._parents.get(uptr);

        if (uparent === lca || uparent === undefined) break;
        uptr = uparent;
      }

      while (true) {
        var vparent = this._parents.get(vptr);

        if (vparent === lca || vparent === undefined) break;
        vptr = vparent;
      }

      return [uptr, vptr];
    }
    /**
     * Return nodes in order from back-to-front, i.e. compound node roots to simple node leaves.
     */

  }, {
    key: "hierarchicalSort",
    value: function hierarchicalSort() {
      var sort = [];
      var visited = new Set();

      var traverse = function traverse(u) {
        if (visited.has(u)) return;
        u.children.forEach(function (child) {
          return traverse(child);
        });
        sort.push(u);
      };

      this._nodes.forEach(function (n) {
        return traverse(n);
      });

      return sort.reverse();
    } // =============================================================================================
    // Traversal of edge structure.

  }, {
    key: "neighbors",
    value: function neighbors(ns) {
      return utils_1.setUnion(this.sources(ns), this.targets(ns));
    }
  }, {
    key: "sources",
    value: function sources(ns) {
      var sources = new Set();
      this.edgesTo(ns).forEach(function (e) {
        return sources.add(e.source.node);
      });
      return sources;
    }
  }, {
    key: "targets",
    value: function targets(ns) {
      var targets = new Set();
      this.edgesFrom(ns).forEach(function (e) {
        return targets.add(e.target.node);
      });
      return targets;
    }
  }, {
    key: "edgesTo",
    value: function edgesTo(ns) {
      if (!utils_1.isIterable(ns)) ns = [ns];
      var edgesTo = new Set();
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = ns[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var node = _step6.value;

          var es = this._edgesTo.get(node);

          if (es) es.forEach(function (e) {
            return edgesTo.add(e);
          });
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      return edgesTo;
    }
  }, {
    key: "edgesFrom",
    value: function edgesFrom(ns) {
      if (!utils_1.isIterable(ns)) ns = [ns];
      var edgesFrom = new Set();
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = ns[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var node = _step7.value;

          var es = this._edgesFrom.get(node);

          if (es) es.forEach(function (e) {
            return edgesFrom.add(e);
          });
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      return edgesFrom;
    }
  }, {
    key: "existsEdge",
    value: function existsEdge(u, v) {
      var undirected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var edgesFrom = this._edgesFrom.get(u);

      if (edgesFrom) {
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
          for (var _iterator8 = edgesFrom[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            var e = _step8.value;
            if (e.target.node === v) return true;
          }
        } catch (err) {
          _didIteratorError8 = true;
          _iteratorError8 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
              _iterator8.return();
            }
          } finally {
            if (_didIteratorError8) {
              throw _iteratorError8;
            }
          }
        }
      }

      if (undirected) {
        var edgesTo = this._edgesTo.get(u);

        if (edgesTo) {
          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = edgesTo[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var _e = _step9.value;
              if (_e.source.node === v) return true;
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }
        }
      }

      return false;
    }
  }, {
    key: "connectedComponents",
    value: function connectedComponents() {
      var _this4 = this;

      var components = new Set();
      var visited = new Set();

      var traverse = function traverse(u, component) {
        if (visited.has(u)) return;
        component.add(u);

        _this4.neighbors(u).forEach(function (neighbor) {
          return traverse(neighbor, component);
        });
      };

      this._nodes.forEach(function (n) {
        if (visited.has(n)) return;
        var component = new Set();
        traverse(n, component);
        components.add(component);
      });

      return components;
    }
  }, {
    key: "topologicalSort",
    value: function topologicalSort() {
      var _this5 = this;

      // TODO: Deal with cycles?
      // TODO: Deal with disjoint components?
      var sort = [];
      var visited = new Set();

      var traverse = function traverse(u) {
        if (visited.has(u)) return;

        var edgesFrom = _this5._edgesFrom.get(u);

        if (edgesFrom) edgesFrom.forEach(function (edge) {
          return traverse(edge.target.node);
        });
        sort.push(u);
      };

      this._nodes.forEach(function (n) {
        return traverse(n);
      });

      return sort.reverse();
    }
  }, {
    key: "shortestPaths",
    value: function shortestPaths() {
      var directed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      // Initialize distances with 1 for directly connected edges. If undefined, the distance is 
      // assumed to be infinity if source and target are different, and 0 if source and target
      // are the same.
      var dist = new Map();

      this._edges.forEach(function (edge) {
        dist.set("".concat(edge.source.id, "|").concat(edge.target.id), 1);
        if (!directed) dist.set("".concat(edge.target.id, "|").concat(edge.source.id), 1);
      }); // Run Floyd-Warshall algorithm to find all-pairs shortest paths.


      var sources, targets, intermediates;

      if (directed) {
        sources = this.sources(this.nodes());
        targets = this.targets(this.nodes());
        intermediates = utils_1.setIntersection(sources, targets);
      } else {
        sources = targets = intermediates = this.neighbors(this.nodes());
      }

      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = intermediates[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var k = _step10.value;
          var _iteratorNormalCompletion11 = true;
          var _didIteratorError11 = false;
          var _iteratorError11 = undefined;

          try {
            for (var _iterator11 = sources[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
              var i = _step11.value;
              var _iteratorNormalCompletion12 = true;
              var _didIteratorError12 = false;
              var _iteratorError12 = undefined;

              try {
                for (var _iterator12 = targets[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                  var j = _step12.value;
                  var dist_ij = i === j ? 0 : dist.get("".concat(i.id, "|").concat(j.id)) || Number.POSITIVE_INFINITY;
                  var dist_ik = i === k ? 0 : dist.get("".concat(i.id, "|").concat(k.id)) || Number.POSITIVE_INFINITY;
                  var dist_kj = k === j ? 0 : dist.get("".concat(k.id, "|").concat(j.id)) || Number.POSITIVE_INFINITY;
                  var dist_ij_new = Math.min(dist_ij, dist_ik + dist_kj);

                  if (Number.isFinite(dist_ij_new)) {
                    dist.set("".concat(i.id, "|").concat(j.id), dist_ij_new);
                  }
                }
              } catch (err) {
                _didIteratorError12 = true;
                _iteratorError12 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
                    _iterator12.return();
                  }
                } finally {
                  if (_didIteratorError12) {
                    throw _iteratorError12;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError11 = true;
            _iteratorError11 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
                _iterator11.return();
              }
            } finally {
              if (_didIteratorError11) {
                throw _iteratorError11;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      return function (u, v) {
        return u === v ? 0 : dist.get("".concat(u.id, "|").concat(v.id));
      };
    }
  }]);

  return StructuredStorage;
}(BasicStorage);

exports.StructuredStorage = StructuredStorage; // TODO: export class QuadTreeStorage extends Storage